<template>
<div class="page-in " style="">



   <div class="row  yo-text-normal "  >
      <div class="col s12 m10m offset-m1m yo-bg-color-tertiary">

   <div class="row"  style="border:2px solid #fff;padding:20px 20px;">

      <div class="col s12 m6 offset-m4" style="color:#353535;">
         <div class="row pad-in" style="padding-top:16px;padding-bottom:16px;">
            <div class="col s3"><img src="../assets/ico-profilo.png" style="width:90%;"/></div>
            <div class="col s9">
               <div class="yo-text-l" style="min-height:50px">{{$contatto.row.cognome}} {{$contatto.row.nome}}</div>
               <router-link to="/contatto-edit"><div>modifica il tuo profilo</div></router-link>
               <router-link to="/contatto-password"><div>modifica password</div></router-link>
               <router-link to="/contatto-privacy"><div>modifica privacy</div></router-link>
            </div>
         </div>
      </div>
      <div class="col s12 m1x offset-ms">
         <div v-on:click="$teras.event.emit('logout')" class="yo-bg-color-mylogin yo-pointer white yo-align-center yo-valign-text-center yo-text-n" style="margin-top:20px;height:46px;">Esci - Logout</div>
      </div>

      <router-link to="/mylogin-res">
      <div class="col s12 m5 offset-m4 yo-valign-text-center yo-text-l" style="background:#FDE1AE;height:80px;border-right:none;margin-top:20px;color:#353535;">
         <div style="margin:0 0 0 30px;">Eventi residenziali / Webinar</div>
      </div>
      <div class="col s12 m1 yo-align-center" style="background:#FDE1AE;height:80px;border-left:none;margin-top:20px;">
         <img src="../assets/ico-residenziale.png" style="height:60px;margin-top:10px;"/>
      </div>
      </router-link>

      <router-link to="/mylogin-fad">
      <div class="col s12 m5 offset-m4 yo-valign-text-center yo-text-l" style="background:#FDE1AE;height:80px;border-right:none;margin-top:20px;color:#353535;">
         <div style="margin:0 0 0 30px;">Eventi FAD</div>
      </div>
      <div class="col s12 m1 yo-align-center" style="background:#FDE1AE;height:80px;border-left:none;margin-top:20px;">
         <img src="../assets/ico-fad.png" style="height:60px;margin-top:10px;"/>
      </div>
      </router-link>
<!-- tolta a settembre 2021 in attesa di integrazione con ital 
      <router-link to="/mylogin-crediti">
      <div class="col s12 m5 offset-m4 yo-valign-text-center yo-text-l" style="background:#FDE1AE;height:80px;border-right:none;margin-top:20px;color:#353535;">
         <div style="margin:0 0 0 30px;">Crediti ECM</div>
      </div>
      <div class="col s12 m1 yo-align-center" style="background:#FDE1AE;height:80px;border-left:none;margin-top:20px;">
         <img src="../assets/ico-crediti.png" style="height:60px;margin-top:10px;"/>
      </div>
      </router-link>
-->
      <router-link to="/home">
      <div class="col s12 m5 offset-m4 yo-valign-text-center yo-text-l" style="background:#FDE1AE;height:80px;border-right:none;margin-top:20px;color:#353535;">
         <div style="margin:0 0 0 30px;">Calendario eventi</div>
      </div>
      <div class="col s12 m1 yo-align-center" style="background:#FDE1AE;height:80px;border-left:none;margin-top:20px;">
         <img src="../assets/ico-calendario.png" style="height:60px;margin-top:10px;"/>
      </div>
      </router-link>

   </div>

</div>
</div>

</div>
</template>

<script>


export default {
   name: 'home',
   components: {

   },
   created () {
      this.$teras.page.title = "Mylogin Eventi Residenziali"
      this.$teras.page.sezione = "myLogin"
   },
   methods: {
      
   }
}
</script>


<style>

</style>



// WEBPACK FOOTER //
// src/components/Mylogin-home.vue